/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { Client } from 'external/lwr-client';
import { ApiUtil, DataUtil } from 'plugin/liferay-widgets-react-web';

let asTypedItem = function (dataList, entries) {
    dataList.item = dataList.item.map((item, idx) => {
        return {
            ...item,
            __type: entries[ idx ].className
        }
    });
    return dataList;
};

let sortByOverallState = function (dataList) {
    dataList.item.sort((item1, item2) => {
        const weight1 = item1.overallState ? item1.overallState.state.weight : -1,
            weight2 = item2.overallState ? item2.overallState.state.weight : -1;
        if (weight1 > weight2) {
            return -1;
        } else if (weight1 < weight2) {
            return 1;
        } else {
            return (item1.title?item1.title:'').localeCompare(item2.title?item2.title:'');
        }
    });
};

const reWriteData = (promise, entries) => {
    return new Promise((resolve, reject) => {
        promise.then(dataList => {
            dataList = asTypedItem(dataList, entries);
            sortByOverallState(dataList);
            resolve(dataList);
        }).catch((error) => {
            reject(error);
        });
    });

};

//const objectFetcherService = (m, o) => Client.invoke('/administration.objectfetcher/' + m, o);
const objectFetcherServiceWithContext = (m, o, c) => Client.invokeWithContext('/administration.objectfetcher/' + m, o, c);

const api = {

    bomList(query) {
        return reWriteData(objectFetcherServiceWithContext('list.3', {
            entries: query.byEntries,
            expand: 'SRI_10,SRI_30,SRI_60,PrecipitationAggregation_10,PrecipitationAggregation_30,PrecipitationAggregation_60,NewestAlarmlevel,NewestStatus,NewestOperationStatus,NewestBasinFillLevel,NewestBasinFillDegree,NewestWaterFlow,NewestWaterLevel,NewestPrecipitationValue, OldestPrecipitationDate'
        }, {}), query.byEntries);
    }

};

ApiUtil.namedApi('BomListWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/BomListWebApi.js